import socketcluster from 'socketcluster-client';
import { Api } from './api';
import { config } from './config';

export const socketsClient = socketcluster.create({
  hostname: Api.BASE_SOCKET_HOST,
  port: config.API_BASE_SOCKET_PORT,
});
